import { useContext, useEffect } from 'react'

import { useAsyncError } from '@/modules/errors'
import { useProjectLoaders } from '@/modules/projects/hooks/project'
import { captureException } from '@/services/monitoring'
import { ProjectContext } from '../ProjectStoreContext'

// The Portfolio tab says when the ledger is short and offers Retry, so a failed page the store
// recorded is not a crash here. Transactions and Insights keep useFetchTransactions and fail loud.
export const useFetchPortfolioLedger = (slug: string) => {
  const { fetchTransactions } = useProjectLoaders()
  const store = useContext(ProjectContext)?.projectStore
  const throwError = useAsyncError()

  // biome-ignore lint/correctness/useExhaustiveDependencies: load once per mount, like useFetchTransactions.
  useEffect(() => {
    fetchTransactions(slug).catch((error: Error) => {
      if (store?.getState().ledgerIncomplete) captureException(error)
      else throwError(error)
    })
  }, [])
}
